module.exports = __webpack_public_path__ + "static/media/dots.59a23c50.png";